import * as React from "react";
import { Checkable } from "@montana/shared/form/checkable";
import { Translate } from "@montana/shared/translate";

export interface IDeliveryAddressPicker {
    currentAddress?: any;
    addresses?: any[];
    setCurrentAddress?: (address?: any) => void;
}

export const DeliveryAddressPicker: React.FC<IDeliveryAddressPicker> = ({ currentAddress, setCurrentAddress, addresses, }: IDeliveryAddressPicker): JSX.Element => {

    const handleCheck = (a?: any): void => {
        setCurrentAddress && setCurrentAddress(a)
    };

    return (
        <div className="delivery-address-picker w-full">
            <h3 className="font-pro-bold text-base leading-5 xl:leading-6 pb-3 w-full">
                <Translate value={(t): string => t.checkoutPage.chooseDeliveryAddress} defaultValue="Choose a delivery address" />
            </h3>

            {/* Altough it might bloat a little, we use rows and cols here for consistency's sake */}
            <div className="row">
                <div className="col w-full md:w-1/2 lg:w-full xl:w-1/2">
                    <hr className="border--extra-light" />
                </div>
                <div className="col w-1/2 hidden md:block lg:hidden xl:block">
                    <hr className="border--extra-light" />
                </div>
            </div>

            <div className="row flex-wrap items-stretch">
                {addresses && addresses.map((a) =>
                    <div key={a.address} className="delivery-address-picker__item col w-full md:w-1/2 lg:w-full xl:w-1/2">
                        <Checkable
                            className="h-full"
                            type="radio"
                            radioGroupValue={currentAddress && currentAddress.address || ""}
                            value={a.address || ""}
                            onCheck={(): void => handleCheck(a)}
                        >
                            <div className="delivery-address-picker__item-content display-body pl-4">
                                <p>{a.address}</p>
                                <p>{a.zip}, {a.city}</p>
                                <p>{a.country}</p>
                            </div>
                        </Checkable>
                    </div>
                )}
            </div>
        </div>
    );
};
